<template>
  <div v-if="intent && !loading">
    <h4 class="mt-3 mb-2 header" style="font-size: 15px">
      {{ $t('this_message_within_24_hours') }}
      {{
        $t(
          `If user hasn't sent message in inbox within 24 hours,The follow-up message won't be sent`
        )
      }}
    </h4>
    <template>
      <div class="form-control" style="display: flow-root">
        <toggle-button
          v-model="intent.follow_up_status"
          :sync="true"
          :color="$vuetify.theme.success"
          :labels="{ checked: 'ON', unchecked: 'OFF' }"
          style="display: inline-block"
        />
        {{ $t('turn_on_follow_up') }}
        <div class="mt-2">{{ $t('send_this_message_following') }}</div>
        <v-flex xs4 class="pl-1">
          <time-picker
            v-model="intent.follow_up_within_seconds"
            class="mt-1"
            full-width
            :min-range="
              !intent.follow_up_within_seconds ||
              (intent.follow_up_within_seconds &&
                (intent.follow_up_within_seconds.HH === '' ||
                  intent.follow_up_within_seconds.HH === '00'))
                ? [[5, 55]]
                : null
            "
            :minute-interval="5"
            hide-disabled-minutes
          ></time-picker>
        </v-flex>
      </div>
    </template>
    <v-layout>
      <v-flex
        v-if="showMultipleChannelFollowUp"
        class="channel"
        shrink
        style="border-right: 1px solid #eee"
      >
        <template v-for="social in conversationSocialChannelOptions">
          <div
            :key="social.value"
            class="py-1 pl-2 pr-2"
            :class="{ 'primary white--text': tab == social.value }"
            style="
              border: 1px solid #eee;
              border-width: 1px 0px 1px 1px;
              border-top-left-radius: 5px;
              border-bottom-left-radius: 5px;
              cursor: pointer;
            "
            @click="tab = social.value"
          >
            <span :class="social.icon"></span>
          </div>
        </template>
      </v-flex>
      <v-flex :key="timestamp" style="overflow: auto">
        <template v-if="!showMultipleChannelFollowUp">
          <template v-if="isReplyComment && isCommentToInbox">
            <intent-group
              v-model="messages"
              :show-multiple-channel="showMultipleChannelFollowUp"
              :available-bubbles="['text', 'image', 'button']"
              :follow-up="true"
              :is-beacon="true"
              @changeSetting="changeSettingFollowUp"
            ></intent-group>
          </template>
          <intent-group
            v-else
            v-model="messages"
            :show-multiple-channel="showMultipleChannelFollowUp"
            :available-bubbles="['text', 'image', 'button']"
            :follow-up="true"
            :hide-setting="true"
            @changeSetting="changeSettingFollowUp"
          ></intent-group>
        </template>
        <template v-else>
          <template v-for="social in conversationSocialChannelOptions">
            <div v-show="social.value == tab" :key="`message-${social.value}`">
              <keep-alive>
                <intent-group
                  :key="`${social.value}_message`"
                  v-model="multiMessages[`follow_up_${social.value}_messages`]"
                  :channel="tab"
                  :show-multiple-channel="showMultipleChannelFollowUp"
                  :available-bubbles="['text', 'image', 'button']"
                  :follow-up="true"
                  @changeSetting="changeSettingFollowUp"
                ></intent-group>
              </keep-alive>
            </div>
          </template>
        </template>

        <div>
          <div class="small" style="margin-top: 10px">{{ $t('Choice') }}</div>
          <div class="mb-3"></div>

          <template v-if="!showMultipleChannelFollowUp">
            <div
              class="form-control"
              :class="{ 'has-error': errorTag['follow_up_replies'].length > 0 }"
            >
              <tags
                v-model="follow_up_reply"
                :tags="follow_up_replies"
                style="margin-bottom: 5px"
                :btn-text="$t('Add choice')"
                @tags-changed="followUpAddReplies('follow_up_replies', $event)"
                @before-adding-tag="checkQuickReply('follow_up_replies', $event)"
              ></tags>
            </div>
          </template>
          <template v-else>
            <template v-for="social in conversationSocialChannelOptions">
              <div
                :key="`message-${social.value}`"
                class="form-control"
                :class="{
                  'has-error':
                    Object.prototype.hasOwnProperty.call(
                      errorTag,
                      `follow_up_${social.value}_replies`
                    ) && errorTag[`follow_up_${social.value}_replies`].length > 0
                }"
              >
                <div v-show="social.value == tab">
                  <tags
                    v-model="multiStringReplies[`follow_up_${tab}_quick_reply`]"
                    :tags="multiReplies[`follow_up_${tab}_quick_reply`]"
                    style="margin-bottom: 5px"
                    :btn-text="$t('Add choice')"
                    @tags-changed="followUpAddReplies(tab, $event)"
                    @before-adding-tag="checkQuickReply(`follow_up_${tab}_replies`, $event)"
                  ></tags>
                </div>
              </div>
            </template>
          </template>
          <div class="form-control has-error">
            <template v-for="(error, errorKey) in errorTag">
              <span v-if="error.length > 0" :key="errorKey" class="text-error">
                <template v-if="error.includes('overmaxlength')">{{
                  $t('Message cannot be longer than 20 alphabets')
                }}</template>
                <template v-else-if="error.includes('overtagmax')">{{
                  $t('Choices cannot be more than 10 items')
                }}</template>
                <template v-else-if="error.includes('duplicate')">{{
                  $t('Duplicate Choice')
                }}</template>
              </span>
            </template>
          </div>
        </div>
      </v-flex>
    </v-layout>
    <div class="mt-4">
      <div class="hr"></div>
      <div class="text-xs-center" style="margin: -13px">
        <a
          class="text btn-advanced"
          href="javascript:void(0);"
          style="position: relative"
          @click="onShowAdvance"
        >
          {{ $t('Advanced') }}
          <i class="fa" :class="{ 'fa-angle-down': !showAdvanced, 'fa-angle-up': showAdvanced }" />
          <!-- <v-premium-lock :inline="true"></v-premium-lock> -->
        </a>
      </div>

      <div
        v-show="showAdvanced || errors.has('context_in') || errors.has('startdate')"
        style="margin-top: 25px"
      >
        <v-tabs v-model="advancedTab" slider-color="primary" touchless show-arrows>
          <v-tab :key="0" ripple>
            {{ $t('Customer') }}
          </v-tab>
          <v-tab v-if="!isCommentToInbox" :key="1" ripple>
            {{ $t('Context') }}
          </v-tab>

          <v-tab :key="3" ripple>
            {{ $t('Line Notify') }}
          </v-tab>

          <v-tab v-if="showIntentGroup" :key="4" ripple>
            {{ $t('Intent Group') }}
          </v-tab>

          <v-tab-item :key="0">
            <v-card
              flat
              :style="{
                'min-height': $store.getters.getPackage != 'premium' ? '250px' : ''
              }"
            >
              <v-premium-plan-popup
                v-if="$store.getters.getPackage != 'premium'"
                :show-all="false"
              ></v-premium-plan-popup>
              <v-card-text>
                <div class="form-control mb-2">
                  <div class="primary--text caption">{{ $t('Status') }}</div>
                  <v-layout wrap>
                    <v-flex sm11>
                      <multiselect
                        v-model="intent.follow_up_userstatus"
                        :options="statusOptions"
                        :multiple="false"
                        :taggable="true"
                        @input="errorMaxlength = false"
                        @tag="onSelectStatus"
                      >
                      </multiselect>
                      <small v-if="errorMaxlength" style="color: red">
                        {{ $t('message_cannot_be_longer_than_25_alphabets') }}</small
                      >
                    </v-flex>
                    <v-flex sm1>
                      <v-btn samll icon @click="intent.follow_up_userstatus = null">
                        <v-icon>close</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </div>
                <div>
                  <div class="primary--text caption mb-1">{{ $t('Tag') }}</div>
                  <tags
                    v-if="tagOptions"
                    v-model="usertag"
                    :combobox="true"
                    :tags="usertags"
                    :item-option="tagOptions"
                    style="margin-bottom: 5px"
                    :btn-text="$t('Add tag')"
                    @tags-changed="addUserTags"
                    @before-adding-tag="checkUserTags"
                  ></tags>
                  <small v-if="errorMaxlengthTags" style="color: red">
                    {{ $t('message_cannot_be_longer_than_25_alphabets') }}</small
                  >
                </div>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item v-if="!isCommentToInbox" :key="1">
            <v-card
              flat
              :style="{
                'min-height': $store.getters.getPackage != 'premium' ? '250px' : ''
              }"
            >
              <v-premium-plan-popup
                v-if="$store.getters.getPackage != 'premium'"
                :show-all="false"
              ></v-premium-plan-popup>
              <v-card-text>
                <v-layout>
                  <v-flex
                    v-if="false"
                    class="form-control pr-1"
                    :class="{ 'has-error': errors.has('context_in') }"
                  >
                    <input
                      v-model="intent.context_in"
                      v-validate="!isCommentToInbox ? 'excluded:comment' : ''"
                      style="margin-bottom: 5px"
                      type="text"
                      class="form-control"
                      placeholder="Context In"
                      data-vv-as="Context In"
                      name="context_in"
                    />
                    <span v-show="errors.has('context_in')" class="text-error">{{
                      $t('Context In cannot be Comment')
                    }}</span>
                  </v-flex>
                  <v-flex class="form-control pl-1">
                    <input
                      v-model="intent.follow_up_context_out"
                      type="text"
                      class="form-control"
                      placeholder="Context Out"
                    />
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :key="2">
            <v-card
              flat
              :style="{
                'min-height': $store.getters.getPackage != 'premium' ? '250px' : ''
              }"
            >
              <v-premium-plan-popup
                v-if="$store.getters.getPackage != 'premium'"
                :show-all="false"
              ></v-premium-plan-popup>
              <v-card-text>
                <div class="primary--text">
                  {{ $t('Line Notify') }}
                </div>
                <v-layout>
                  <v-flex xs8 class="pt-3">
                    {{ $t('Turn on/off Line Notify') }}
                  </v-flex>
                  <v-flex xs4 class="text-xs-right">
                    <template v-if="$store.state.linenotifylist.length == 0"></template>
                    <template
                      v-else-if="
                        (selectedBot.notify_intent && !isCommentToInbox) ||
                        (selectedBot.notify_comment && isCommentToInbox)
                      "
                    >
                      <toggle-button
                        class="mt-2"
                        :value="intent.follow_up_linenoti_status"
                        :sync="true"
                        :color="$vuetify.theme.success"
                        :labels="{ checked: 'ON', unchecked: 'OFF' }"
                        style="display: inline-block"
                        @change="toggleLineNotifyStatus"
                      />
                    </template>
                  </v-flex>
                </v-layout>
                <div class="col s12">
                  <template v-if="$store.state.linenotifylist.length == 0">
                    {{ $t('You are not connected to Line Notify.') }}
                    <router-link to="billing">{{
                      $t('Click to connected Line Notify at the settings page')
                    }}</router-link>
                  </template>
                  <template
                    v-else-if="
                      (selectedBot.notify_intent && !isCommentToInbox) ||
                      (selectedBot.notify_comment && isCommentToInbox)
                    "
                  >
                    <div class="form-control">
                      <textarea
                        v-model="intent.follow_up_linenoti_text"
                        class="form-control"
                        :placeholder="$t('Message')"
                        maxlength="2000"
                      ></textarea>
                    </div>

                    <!-- Select line notify -->
                    <div>{{ $t('Select Line Account') }}</div>
                    <v-combobox
                      v-model="selectLinenotify"
                      :items="$store.state.linenotifylist"
                      :item-text="'name'"
                      :item-value="'id'"
                      multiple
                      chips
                      outline
                      single-line
                      @change="selectLinenotifyUserId()"
                    >
                      <template #selection="data">
                        <v-chip
                          :key="JSON.stringify(data.item)"
                          :selected="data.selected"
                          :disabled="data.disabled"
                          class="v-chip--select-multi"
                          @input="data.parent.selectItem(data.item.adminid)"
                        >
                          <v-avatar>
                            <v-img
                              :src="`https://graph.facebook.com/${data.item.adminid}/picture?type=square&SameSite=None`"
                            ></v-img>
                          </v-avatar>
                          {{ data.item.name }}
                        </v-chip>
                      </template>
                    </v-combobox>
                  </template>
                  <template v-else>
                    {{ $t('Not yet alert via Line Notify.') }}
                    <router-link to="billing">{{
                      $t('Click to connected Line Notify at the settings page')
                    }}</router-link>
                  </template>
                </div>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :key="4">
            <v-card
              flat
              :style="{
                'min-height': $store.getters.getPackage != 'premium' ? '250px' : ''
              }"
            >
              <v-premium-plan-popup
                v-if="$store.getters.getPackage != 'premium'"
                :show-all="false"
              ></v-premium-plan-popup>
              <v-card-text>
                <template v-if="showIntentGroup">
                  <div>
                    <v-layout row wrap>
                      <v-flex
                        xs12
                        sm6
                        class="form-control px-1 pb-2"
                        :class="{ 'has-error': errors.has('group') }"
                      >
                        <div class="caption mb-1 mt-2">Group *</div>
                        <multiselect
                          v-model="ticket.group"
                          :options="agentGroup"
                          track-by="groupname"
                          label="groupname"
                          name="group"
                          :searchable="true"
                          select-label
                          selected-label
                          deselect-label
                          @input="onChangeGroup"
                        ></multiselect>
                        <p v-if="errors.has('group')" class="text-error">
                          {{ errors.first('group') }}
                        </p>
                      </v-flex>
                      <v-flex v-if="ticket.group" xs12 sm6 class="form-control px-1 pb-2">
                        <div class="caption mb-1 mt-2">Subgroup</div>
                        <v-layout>
                          <multiselect
                            v-model="ticket.subgroup"
                            :options="filterSubGroup"
                            track-by="subgroupname"
                            label="subgroupname"
                            :searchable="true"
                            select-label
                            selected-label
                            deselect-label
                          ></multiselect>
                          <v-btn small flat fab class="my-0" @click="ticket.subgroup = null">
                            <v-icon>close</v-icon>
                          </v-btn>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <div class="caption mb-1 mt-2">Priority *</div>
                        <multiselect
                          :key="`priority`"
                          v-model="ticket.priority"
                          class="mb-3"
                          :options="priorityOptions"
                          label="text"
                          select-label
                          selected-label
                          :allow-empty="false"
                          :searchable="false"
                          deselect-label
                          track-by="text"
                        ></multiselect>
                      </v-flex>
                      <v-flex xs12>
                        <div class="caption mb-1 mt-2">Tags</div>
                        <template v-if="selectedBot.theme == 'toa'">
                          <TagManagement
                            v-model="ticket.tags"
                            :items="ticketTagsFull"
                            :filter="tagsfilter"
                            @onDirty="
                              () => {
                                isDirtyTagManagement = true
                              }
                            "
                          />
                        </template>
                        <v-combobox
                          v-else
                          v-model="ticket.tags"
                          :filter="tagsfilter"
                          :hide-no-data="!tagssearch"
                          :items="tagitems"
                          :search-input.sync="tagssearch"
                          hide-selected
                          label="Search for an option"
                          multiple
                          small-chips
                          solo
                        >
                          <template #no-data>
                            <v-list-tile>
                              <span class="subheading">Create</span>
                              <v-chip :color="`primary lighten-3`" label small>{{
                                tagssearch
                              }}</v-chip>
                            </v-list-tile>
                          </template>
                          <template #selection="{ item, parent, selected }">
                            <v-chip
                              v-if="item === Object(item)"
                              :color="`primary lighten-3`"
                              :selected="selected"
                              label
                              small
                            >
                              <span class="pr-2">{{ item.text }}</span>
                              <v-icon small @click="parent.selectItem(item)">close</v-icon>
                            </v-chip>
                          </template>
                          <template #item="{ index, item }">
                            <v-list-tile-content>
                              <v-text-field
                                v-if="tagediting === item"
                                v-model="tagediting.text"
                                autofocus
                                flat
                                background-color="transparent"
                                hide-details
                                solo
                                @keyup.enter="tagsedit(index, item)"
                              ></v-text-field>
                              <v-chip v-else :color="`primary lighten-3`" label small>{{
                                item.text
                              }}</v-chip>
                            </v-list-tile-content>
                            <v-spacer></v-spacer>
                            <v-list-tile-action @click.stop>
                              <v-btn icon @click.stop.prevent="tagsedit(index, item)">
                                <v-icon>{{ tagediting !== item ? 'edit' : 'check' }}</v-icon>
                              </v-btn>
                            </v-list-tile-action>
                          </template>
                        </v-combobox>
                      </v-flex>
                    </v-layout>
                    <div>Due Date</div>
                    <v-divider></v-divider>
                    <v-layout wrap style="margin-top: 24px">
                      <v-flex xs4 class="px-1 form-control">
                        <div class="caption">Day</div>
                        <input
                          v-model.number="ticket.day"
                          placeholder="Days"
                          type="number"
                          @input="ticket.day = numberOnly($event, 'day')"
                        />
                      </v-flex>
                      <v-flex xs4 class="px-1 form-control">
                        <div class="caption">Hour</div>
                        <input
                          v-model.number="ticket.hour"
                          placeholder="Hour"
                          type="text"
                          @input="ticket.hour = numberOnly($event, 'hour')"
                        />
                      </v-flex>
                      <v-flex
                        xs4
                        class="px-1 form-control"
                        :class="{ 'has-error': errors.has('Minute') }"
                      >
                        <div class="caption">Minute</div>
                        <input
                          v-model.number="ticket.minute"
                          v-validate="'max_value:59'"
                          name="Minute"
                          placeholder="Minute"
                          type="text"
                          @input="ticket.minute = numberOnly($event, 'minute')"
                        />
                        <p v-if="errors.has('Minute')" class="text-error">
                          {{ errors.first('Minute') }}
                        </p>
                      </v-flex>
                    </v-layout>
                  </div>
                </template>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </div>
    </div>
    <div class="mt-4" style="margin-bottom: 15px; text-align: center">
      <a href="javascript:void(0);" class="btn-preview" @click="showPreview = true">
        <em class="far fa-eye" />
        {{ $t('preview') }}
      </a>
      <preview-message
        v-if="showPreview"
        :messages="previewMessage"
        :choice="quickReplyPreview"
        @close="showPreview = false"
      ></preview-message>
    </div>
  </div>
</template>

<script>
import Tags from '@/components/elements/Tags'
import PreviewMessage from '@/components/elements/PreviewMessage'
import IntentGroup from './IntentGroup'
import TimePicker from '@/components/elements/TimePicker.vue'
import { ToggleButton } from 'vue-js-toggle-button'
import cloneDeep from 'lodash/cloneDeep'
import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'
import ticketApi from '@/api/ticket'
import { handleResponse, handleApiError } from '@/api/util'
import TagManagement from '@/components/view/ticket/TagManagement'

export default {
  components: {
    Tags,
    PreviewMessage,
    IntentGroup,
    TimePicker,
    ToggleButton,
    Multiselect,
    TagManagement
  },
  props: {
    intent: {
      default: null,
      type: Object
    },
    isCommentToInbox: { default: false },
    isReplyComment: { deafult: false },
    isWelcome: { default: false },
    timestamp: {},
    statusOptions: {},
    tagOptions: {},
    follow_up_selectLinenotify: {}
  },
  data() {
    return {
      tagssearch: null,
      selectLinenotify: this.follow_up_selectLinenotify,
      usertag: '',
      advancedTab: null,
      showAdvanced: false,
      errorMaxlengthTags: false,
      errorMaxlength: false,
      showPreview: false,
      showMultipleChannelFollowUp: false,
      messages: [[]],
      follow_up_reply: '',
      multiMessages: {},
      multiReplies: {},
      multiStringReplies: {},
      tab: 'all',
      errorTag: {
        follow_up_replies: []
      },
      loading: true,
      ticket: {
        assigngroupid: '',
        assignsubgroupid: '',
        priority: '',
        group: '',
        subgroup: '',
        tags: [],
        day: 0,
        hour: 0,
        minute: 0,
        duedate: {
          start: '',
          starttime: '',
          end: ''
        }
      },
      priorityOptions: [
        {
          text: 'Low',
          value: 'low'
        },
        {
          text: 'Medium',
          value: 'medium'
        },
        {
          text: 'High',
          value: 'high'
        }
      ],
      tagitems: [{ header: 'Select an option or create one' }]
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      ticketTags: 'ticketTags',
      ticketTagsFull: 'ticketTagsFull',
      agentGroup: 'getAgentGroup',
      agentSubGroup: 'getAgentSubgroup'
    }),
    filterSubGroup() {
      if (this.ticket.group) {
        return this.agentSubGroup.filter((el) => {
          return el.admingroupid == this.ticket.group.id
        })
      } else {
        return []
      }
    },
    showIntentGroup: function () {
      if (['autocash'].includes(this.selectedBot.type)) {
        return true
      } else {
        return false
      }
    },
    previewMessage: function () {
      if (this.tab == 'all') {
        return this.messages || [[]]
      } else {
        return this.multiMessages[`follow_up_${this.tab}_val`] || [[]]
      }
    },
    quickReplyPreview() {
      if (this.tab == 'all') {
        return this.follow_up_replies || []
      } else {
        return this.multiReplies[`follow_up_${this.tab}_replies`] || []
      }
    },
    follow_up_replies: {
      get() {
        if (
          this.intent &&
          this.intent.follow_up_quick_reply &&
          this.intent.follow_up_quick_reply !== ''
        ) {
          var quick_replies = []
          quick_replies = this.intent.follow_up_quick_reply.split(',')

          var result = []
          try {
            result = quick_replies.map((val) => {
              return { text: val }
            })
          } catch (error) {
            console.error(error)
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        var result = []
        try {
          result = value.map((el) => {
            return el.text
          })
        } catch (error) {
          console.error(error)
        }
        this.$set(this.intent, 'follow_up_quick_reply', result.join(','))
      }
    },
    follow_up_multi_channel_replies: {
      get() {
        if (this.tab == 'all') return []
        if (
          this.intent &&
          this.intent[`follow_up_${this.tab}_quick_reply`] &&
          this.intent[`follow_up_${this.tab}_quick_reply`] !== ''
        ) {
          var quick_replies = []

          if (this.intent.a_type === 'message' || this.intent.a_type === 'generic') {
            if (this.setting.welcome_quickreplies) {
              quick_replies = this.setting.welcome_quickreplies.contentvalue.split(',')
            }
          } else {
            quick_replies = this.intent[`follow_up_${this.tab}_quick_reply`].split(',')
          }
          var result = []
          try {
            result = quick_replies.map((val) => {
              return { text: val }
            })
          } catch (error) {
            console.error(error)
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        var result = []
        try {
          result = value.map((el) => {
            return el.text
          })
        } catch (error) {
          console.error(error)
        }
        this.$set(this.intent, 'follow_up_ig_quick_reply', result.join(','))
      }
    },
    usertags: {
      get() {
        const vm = this
        if (vm.intent && vm.intent.follow_up_usertags && vm.intent.follow_up_usertags !== '') {
          var usertags = []

          usertags = vm.intent.follow_up_usertags.split(',')
          var result = []
          if (usertags) {
            try {
              result = usertags.map(function (tag) {
                return { text: tag }
              })
            } catch (error) {
              console.error(error)
            }
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        const vm = this
        var result = []
        if (value) {
          result = value.map(function (tag) {
            return tag.text
          })
        }

        vm.$set(this.intent, 'follow_up_usertags', result.join(','))
      }
    }
  },
  watch: {
    messages: {
      handler(newVal) {
        this.$set(this.intent, 'follow_up_val', newVal)
      },
      deep: true
    },
    ticket: {
      handler(newVal) {
        this.$set(this.intent, 'follow_up_intentgroup', newVal)
      },
      deep: true
    },
    tickettags(val, prev) {
      if (val.length === prev.length) return

      this.ticket.tags = val.map((v) => {
        if (typeof v === 'string') {
          v = {
            text: v
          }
          this.$nextTick(() => {
            this.tagitems.push(v)
            this.$forceUpdate()
          })
        }

        return v
      })
    },
    multiMessages: {
      handler(newVal) {
        this.conversationSocialChannelOptions.forEach((social) => {
          this.$set(
            this.intent,
            `follow_up_${social.value}_val`,
            newVal[`follow_up_${social.value}_messages`]
          )
        })
      },
      deep: true
    },
    multiReplies: {
      handler(newVal) {
        this.conversationSocialChannelOptions.forEach((social) => {
          this.$set(
            this.intent,
            `follow_up_${social.value}_replies`,
            newVal[`follow_up_${social.value}_replies`]
          )
        })
      },
      deep: true
    }
  },
  async mounted() {
    const errorTag = this.conversationSocialChannelOptions.reduce((prev, curr) => {
      prev[`follow_up_${curr.value}_replies`] = []
      return prev
    }, {})
    this.errorTag = { ...this.errorTag, ...errorTag }
    const hasMultipleChannel = this.conversationSocialChannelOptions.find((social) => {
      return (
        Object.prototype.hasOwnProperty.call(this.intent, `follow_up_${social.value}_val`) &&
        this.intent[`follow_up_${social.value}_val`]
      )
    })
    if (hasMultipleChannel) {
      this.showMultipleChannelFollowUp = true
      this.conversationSocialChannelOptions.forEach((social) => {
        let json = [[]]
        try {
          json = Object.prototype.hasOwnProperty.call(this.intent, `follow_up_${social.value}_val`)
            ? this.isJsonParseable(this.intent[`follow_up_${social.value}_val`])
              ? JSON.parse(this.intent[`follow_up_${social.value}_val`])
              : this.intent[`follow_up_${social.value}_val`]
            : [[]]
        } catch (error) {
          console.error(error)
        }
        this.multiMessages[`follow_up_${social.value}_messages`] = json

        const quick_replies = this.intent[`follow_up_${social.value}_quick_reply`]
          ? this.intent[`follow_up_${social.value}_quick_reply`].split(',')
          : []
        this.multiReplies[`follow_up_${social.value}_quick_reply`] = quick_replies
        this.multiStringReplies[`follow_up_${social.value}_quick_reply`] = ''
      })
      this.tab = hasMultipleChannel.value
    }
    if (this.intent && this.intent.follow_up_val) {
      const messages = this.isJsonParseable(this.intent.follow_up_val)
        ? JSON.parse(this.intent.follow_up_val)
        : this.intent.follow_up_val
      this.messages = this.checkEmptyMessage(messages)
    } else {
      this.messages = [[]]
    }

    if (this.intent && this.intent.follow_up_intentgroup) {
      const ticket = this.isJsonParseable(this.intent.follow_up_intentgroup)
        ? JSON.parse(this.intent.follow_up_intentgroup)
        : this.intent.follow_up_intentgroup
      ticket.group = ticket.assigngroupid
        ? this.agentGroup.find((el) => el.id == ticket.assigngroupid)
        : null
      ticket.assignsubgroupid = ticket.assignsubgroupid
        ? this.agentGroup.find((el) => el.id == ticket.assignsubgroupid)
        : null
      ticket.priority = ticket.priority
        ? this.priorityOptions.find((el) => el.value == ticket.priority)
        : null
      this.ticket = ticket ? ticket : this.ticket
    }
    await this.$nextTick()
    this.loading = false
  },
  methods: {
    selectLinenotifyUserId() {
      const vm = this
      vm.$emit('update:follow_up_selectLinenotify', vm.selectLinenotify)
    },
    async onChangeGroup() {
      this.ticket.subgroup = null
      this.ticket.assignedTo = null
    },
    addUserTags: function (newTags) {
      const vm = this
      vm.usertags = newTags
    },
    checkUserTags(obj) {
      const vm = this
      vm.errorUserTags = []
      if (obj.tag.text == '') {
        //
      } else if (obj.tag.text.length > 25) {
        vm.errorUserTags.push('overmaxlength')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        vm.errorUserTags.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    onShowAdvance: function () {
      const vm = this
      vm.showAdvanced = !vm.showAdvanced
    },
    toggleLineNotifyStatus: function () {
      const vm = this
      vm.$set(vm.intent, 'follow_up_linenoti_status', !vm.intent.follow_up_linenoti_status)
    },
    onSelectStatus(value) {
      const vm = this
      if (value.length <= 25) {
        vm.errorMaxlength = false
        vm.$set(vm.intent, 'follow_up_userstatus', value)
      } else {
        vm.errorMaxlength = true
      }
    },
    followUpAddReplies(type, newTags) {
      if (this.conversationSocialChannelOptions.some((social) => type == social.value))
        this.multiReplies[`follow_up_${type}_replies`] = newTags
      else this.follow_up_replies = newTags
    },
    checkQuickReply(type, obj) {
      this.errorTag[type] = []
      if (obj.tag.text == '') {
        //
      } else if (obj.tag.text.length > 20) {
        this.errorTag[type].push('overmaxlength')
        obj.error()
      } else if (
        obj.type == 'add' &&
        this.conversationSocialChannelOptions.some(
          (social) =>
            type == `follow_up_${social.value}_replies` &&
            this.multiReplies[`follow_up_${social.value}_replies`].length >= 10
        )
      ) {
        this.errorTag[type].push('overtagmax')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        // this.replies.map(t => t.text).indexOf(obj.tag.text) !== -1s
        this.errorTag[type].push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    async changeSettingFollowUp(payload) {
      if (Object.hasOwnProperty.call(payload, 'showMultipleChannel')) {
        if (
          this.showMultipleChannelFollowUp != payload.showMultipleChannel &&
          payload.showMultipleChannel == true
        ) {
          let cloneMessages = null
          if (this.isWelcome) {
            try {
              await this.$nextTick()
              let { messages } = this.$store.getters.welcomeMessage('all')
              cloneMessages = messages
            } catch (error) {
              console.error(error)
            }
          } else {
            cloneMessages = this.messages
          }

          this.conversationSocialChannelOptions.forEach((social) => {
            if (social.value == 'fb' || social.value == 'ig') {
              this.$set(
                this.multiMessages,
                `follow_up_${social.value}_messages`,
                cloneDeep(
                  cloneMessages.map((el) => {
                    return el.filter((sel) => {
                      return !['flex', 'imagemap', 'sticker'].includes(sel.type)
                    }, [])
                  }, [])
                )
              )
            } else {
              this.$set(
                this.multiMessages,
                `follow_up_${social.value}_messages`,
                cloneDeep(cloneMessages)
              )
            }
            if (!this.isWelcome)
              this.$set(
                this.intent,
                `follow_up_${social.value}_quick_reply`,
                this.intent.quick_reply
              )
          })
        }
        this.showMultipleChannelFollowUp = payload.showMultipleChannel

        if (this.showMultipleChannelFollowUp) this.tab = 'fb'
        else this.tab = 'all'
      }

      this.$emit('changeSetting', payload)
    },
    tagsfilter(item, queryText, itemText) {
      if (item.header) return false

      const hasValue = (val) => (val != null ? val : '')

      const text = hasValue(itemText)
      const query = hasValue(queryText)

      return text.toString().toLowerCase().indexOf(query.toString().toLowerCase()) > -1
    },
    async tagsedit(index, item) {
      this.showEditTicketTag = !this.showEditTicketTag
      if (!this.tagediting) {
        this.tagediting = item
        this.index = index
      } else {
        //save tag
        const result = await this.handleEditTicketTag(item, this.tagediting)
        if (result) {
          //clear tag
          const tagIndex = this.ticketTagsFull.findIndex((el) => el.id != item.id)
          if (tagIndex != -1) {
            const tags = this.ticketTagsFull
            tags[tagIndex] = this.tagediting
            this.$store.commit('SET_TICKET_TAGS_FULL', tags)
          }
          this.tagediting = null
          this.index = -1
        }
      }
    },
    async handleEditTicketTag(item, newVal) {
      try {
        const tag = this.ticketTagsFull.find((tag) => {
          return tag && item && tag.name.toLowerCase() == item.name.toLowerCase()
        })

        if (tag && newVal) {
          const response = await ticketApi.putEditTicketTag({
            data: { pageid: this.selectedBot.pageid, id: tag.id, ticket_tag: newVal.name }
          })
          await handleResponse(response)
          return true
        }
      } catch (error) {
        handleApiError(error)
        return false
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/intent/FollowUpMessages.vue